import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import "core-js/modules/es.object.to-string.js";
import { getMaiaOnlineParams } from '@/api/maia.js';
// 动态获取key
var state = {
  maiaParams: {}
};
var mutations = {
  // 更新在线参数
  UPDATE_ONLINE_PARAMS: function UPDATE_ONLINE_PARAMS(state, paramObj) {
    state.maiaParams = paramObj;
  }
};
var actions = {
  // 获取在线参数
  getOnlineParams: function getOnlineParams(_ref) {
    var commit = _ref.commit,
        state = _ref.state;
    return new Promise(function (resolve, reject) {
      getMaiaOnlineParams().then(function (res) {
        commit('UPDATE_ONLINE_PARAMS', res.data);
        resolve();
      }).catch(function (err) {
        _Message({
          message: err,
          type: 'error',
          duration: 2 * 1000,
          onClose: function onClose() {
            window.MessageShow = false;
          }
        });

        reject(err);
      });
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};